// @ts-nocheck
export const createCartStore = (initialState = null) => {
  let state = initialState;
  const subscribers = new Set();

  const get = () => state;

  const set = (newState) => {
    state = newState;
    subscribers.forEach((callback) => callback(state));
  };

  const subscribe = (callback) => {
    subscribers.add(callback);
    return () => {
      subscribers.delete(callback);
    };
  };

  return {
    get,
    set,
    subscribe,
  };
};
